import type * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as mosaicModels from '../../../../models'
import type * as models from '../../models'

import type { Plugin } from './plugin'
import type { State } from './state'

/**
 * Core actions for this {@link Plugin}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    /**
     * Retrieves a preview of the requested {@link ents.core.mosaic.Widget}
     */
    preview: store.actions.request({
      input: store.actions.Data.asIs<{
        refId: mosaicModels.widget.Ref.Id
        flexibleIdentifier: ents.core.common.FlexibleIdentifier<ec.models.EntityId>
      }>(),
      output: store.actions.Data.asIs<{
        readonly preview: models.widget.Preview
      }>(),
      reducers: {
        request: ({ state, data: { refId } }) => ({
          ...state,
          lookup: {
            ...state.lookup,
            [refId]: { isLoading: true },
          },
        }),
        error: ({
          state,
          data: {
            error,
            request: { refId },
          },
        }) => ({
          ...state,
          lookup: {
            ...state.lookup,
            [refId]: { error },
          },
        }),
        success: ({
          state,
          data: {
            response: { preview },
            request: { refId },
          },
        }) => ({
          ...state,
          lookup: {
            ...state.lookup,
            [refId]: { preview },
          },
        }),
      },
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
